/**
 * Add components by event and in your desired order
 * @type {[*]}
 */
let components = [
    [
        "ready",
        [
            require("./../lib/equal-heights"),
            require("./../components/squares"),
            require("./../components/cookie-notice"),
            require("./../components/dropdown-navigation"),
            require("./../components/general"),
            require("./../components/form"),
            require("./../components/play-media"),
            require("./../components/scroller"),
            require("./../components/trigger"),
            require("./../components/filter"),
            require("./../components/filter-lazy-load"),
            require("./../components/slider"),
            require("./../components/waypoints"),
            require("./../components/popup"),
            require("./../components/menu"),
            require("./../components/lavalamp"),
            require("./../components/ticker"),
            require("./../components/treatments"),
            require("./../components/store-locator"),
            require("./../components/opening-hours"),
            require("./../components/flowbox"),
            require("./../components/appointment-button"),
        ],
    ],
];

module.exports = components;
